import { BiMap } from "../helpers/BiMap";

export const substrateKpis = {
  soil_climate: [
    "total_24hr_ml_in",
    "total_24hr_ml_out",
    "run_off",
    "avg_24hr_run_off",
    "moisture_content",
    "gains",
    "vic",
    "soil_temp",
  ],
  agronomics: [
    "ag_ph_in",
    "ag_ph_out",
    "ag_ec_in",
    "ag_ec_out",
    "ag_ec_bag",
    "ag_ec_sum",
  ],
  ambient_climate: ["ambient_temp", "humidity", "vpd", "delta_t"],
  disease_risk: ["mildew"],
};
export const soilKpis = {
  daily: {
    soil_climate: ["gains"],
  },
  soil_climate: [
    "moisture_content",
    "smd",
    "rainfall",
    "irri_trigger",
    "predicted_irri",
    "total_24hr_gains",
    "total_24hr_ml_in",
    "total_24hr_ml_out",
  ],
  agronomics: [],
  ambient_climate: ["ambient_temp", "humidity", "delta_t"],
  disease_risk: [],
};

export const moduleIdMap = new BiMap([
  ["soil_climate", 4],
  ["agronomics", 2],
  ["ambient_climate", 3],
  ["disease_risk", 1],
]);
